<template>
    <div class="section mincho"
        :class="sectionClass"
        @click.stop="start()"
        @keydown="keyEvent"
        tabindex="0"
        id="sectionPane"
        v-if="section.body">
        <div class="book-title" v-if="!prev">
            <h3 itemprop="title">
                <span v-html="$filters.ruby(section.book.title)"></span>
            </h3>
        </div>
        <div class="book-title" v-if="!prev && section.book.subtitle">
            <h4 v-if="section.book.subtitle" itemprop="subtitle" v-html="$filters.ruby(section.book.subtitle)"></h4>
        </div>
        <div class="book-caption overflow-hidden" :class="{
            'hover-title': $store.state.is_horizontal == 0,
            'd-none': $store.state.is_horizontal && !prev
        }">
            <h3 class="m-0 p-0" itemprop="title" @click.stop="">
                <router-link :to="`/author/book/${section.book_id}`" v-if="section.book.is_long" class="text-reset">
                    <span v-html="$filters.ruby(section.book.title)"></span>
                </router-link>
                <span v-else v-html="$filters.ruby(section.book.title)"></span>
            </h3>
        </div>
        <div class="section-title">
            <h5
                :class="[$store.getters.fontSize]" v-html="$filters.ruby(section.section_name)"></h5>
        </div>
        <div class="section-body"
            :class="[$store.getters.fontSize]">
            <span v-html="$filters.ruby(archive)"></span><!--
            --><span v-html="$filters.ruby(done)"></span><!--
            --><span v-html="$filters.ruby(curr, append)"></span>
        </div>
        <reading-tracker
            :body="this.section.body"
            :startReading="startReading"
            @close="startReading = false"></reading-tracker>
    </div>
</template>

<style scoped lang="scss">
.section {
    line-height: 2.2em;
    max-width: 860px;
    margin: 0 auto;
    letter-spacing: .2rem;
    padding: 0 3.5rem 1rem;
    font-size: 1.2rem;
    transition: 0.3s ease;
    outline: none;
    .font-s { font-size: 1.0rem; line-height: 2.2rem; }
    .font-m { font-size: 1.1rem; line-height: 2.4rem; }
    .font-l { font-size: 1.2rem; line-height: 2.6rem; }
    .font-x { font-size: 1.3rem; line-height: 2.8rem; }
    .font-h { font-size: 1.4rem; line-height: 3.0rem; }
    &.loading {
        color: transparent;
    }
    .book-title {
        padding: 2rem 2rem 1.5rem;
        margin: 0 auto;
        text-align: center;
        h3 {
            display: inline-block;
            font-size: 2rem;
            text-align: left;
        }
        h4 {
            display: inline-block;
            font-size: .9rem;
            color: #777;
            text-align: left;
        }
    }
    .book-caption {
        h3 {
            font-size: .65rem;
        }
        text-align: right;
        height: 2rem;
        padding-top: .5rem;
    }
    .section-title {
        margin: 2rem auto 4rem;
        text-align: center;
        h5 {
            text-align: left;
            display: inline-block;
            &.font-s { font-size: 1.4rem; }
            &.font-m { font-size: 1.5rem; }
            &.font-l { font-size: 1.6rem; }
            &.font-x { font-size: 1.8rem; }
            &.font-h { font-size: 2.0rem; }
        }
    }
    .section-body {
        overflow: hidden;
    }
    .hover-title {
        position: fixed;
        bottom: .5rem;
        left: 0;
        width: 100vw;
        text-align: center;
        writing-mode: horizontal-tb;
        text-orientation: none;
        line-height: .9rem;
    }
    &.vertical-s {
        height: calc(100dvh - 20px);
        max-width: 100%;
        min-width: calc(100vw - 300px);
        padding: 14rem 0 14rem 1rem;
        .section-title {
            margin: 0 2rem;
            padding: 0 2rem;
        }
    }
    &.vertical-p {
        height: calc(100dvh - 250px);
        max-width: 100%;
        min-width: calc(100vw - 300px);
        padding: 6.0rem 0 6.0rem 1rem;
        .section-title {
            margin: 0 2rem;
            padding: 0 2rem;
        }
    }
}
@media screen and (max-height: 1000px) {
    .section {
        &.vertical-s {
            height: calc(var(--vh, 1vh) * 100);
            padding: 6rem 0 6rem 1rem;
        }
        &.vertical-p {
            height: calc(100dvh - 170px);
            padding: 6rem 0 6rem 1rem;
        }
    }
}
@media screen and (max-width: 770px) {
    .section {
        padding: 0 .5rem 1rem;
        font-size: .9rem;
        .font-s { font-size: 0.9rem; line-height: 1.9rem; }
        .font-m { font-size: 1.0rem; line-height: 2.0rem; }
        .font-l { font-size: 1.1rem; line-height: 2.1rem; }
        .font-x { font-size: 1.2rem; line-height: 2.2rem; }
        .font-h { font-size: 1.3rem; line-height: 2.3rem; }
        &.vertical-s {
            height: calc(var(--vh, 1vh) * 100);
            padding: 3.2rem 0 3.2rem 1rem;
        }
        &.vertical-p {
            height: calc(100dvh - 170px);
            padding: 3.2rem 0 3.2rem 1rem;
        }
    }
}
</style>

<script>
import readingTracker from "./reading-tracker.vue";
export default {
    components: {
        readingTracker
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        section: {
            required: true,
        },
        preview: {
            default: false,
        },
        prev: {
            default: null,
        },
    },
    data() {
        return {
            initialized: false,    // 初期化フラグ
            archive: "",
            done: "",
            curr: "",
            pos: 0,         // カーソル位置
            period: 0,      // 句点カウンタ
            timerId: null,  // 文字打ちタイマー
            saveId: null,   // カーソル位置保存タイマー
            next: "",
            audio: null,
            source: null,
            buffer: null,
            startReading: false,
        }
    },
    methods: {
        init() {
            this.archive = "";
            this.done = "";
            this.curr = "";
            if (this.$store.state.output_style) {
                this.$emit("finished", false);
                if (this.pos) {
                    // 復帰
                    this.archive = this.section.body.substring(0, this.pos);
                    if (this.finished) {
                        this.$emit("finished", true);
                    }
                }
                if (this.$store.state.sound_effect) {
                    axios.get("/wav/se" + this.$store.state.sound_effect + ".wav", {responseType: "arraybuffer"}).then(res => {
                        this.buffer = res.data;     // デコード前生データ
                        this.audio = null;
                        this.initialized = true;
                    });
                } else {
                    this.initialized = true;
                }
                if (!this.$store.state.sound_effect) {
                    this.start();
                }
            } else {
                this.initialized = false;
                this.archive = this.section.body;
                this.$emit("finished", true);
            }
            setTimeout(() => $("#sectionPane").focus());
        },
        start() {
            if (!this.initialized) return;
            if (!this.audio && this.$store.state.sound_effect) {
                window.AudioContext = window.AudioContext || window.webkitAudioContext;
                this.audio = new AudioContext();
                this.audio.decodeAudioData(this.buffer, (buf) => {
                    this.buffer = buf;  // デコード済み
                    this.source.buffer = buf;
                    this.source.loop = false;
                });
                this.source = this.audio.createBufferSource();
                this.source.connect(this.audio.destination);
            }
            let speed = 10;
            if (this.saveId) {
                clearTimeout(this.saveId);
            }
            if (this.timerId) {
                clearTimeout(this.timerId);
            } else {
                if (this.$store.state.output_style == 1) {
                    speed = 75;
                } else if (this.$store.state.output_style == 2) {
                    speed = 50;
                } else if (this.$store.state.output_style == 3) {
                    speed = 20;
                }
                if (this.done.length > 5000) {
                    this.archive = this.done;
                    this.done = "";
                }
            }
            this.timerId = setTimeout(this.increment, speed, speed);
        },
        stop() {
            clearTimeout(this.timerId);
            this.done += this.curr;
            this.curr = "";
            this.timerId = null;
            this.saveId = setTimeout(() => {this.savePos()}, 5000);
        },
        increment(interval) {
            try {
                const scrolled = parseInt(this.pos / this.section.body.length * 100);
                this.$emit("scrolled", scrolled);
                let char = this.section.body.substring(this.pos, this.pos + 1);
                this.pos++;
                this.next = this.section.body.substring(this.pos, this.pos + 1);
                if (this.next && this.next.match(/[《]/u)) {
                    const match = this.section.body.substring(this.pos).match(/^[《][^》]+[》]/);
                    if (match) {
                        char += match[0];
                        this.pos += match[0].length;
                        this.next = this.section.body.substring(this.pos, this.pos + 1);
                    }
                }
                if (this.$store?.state?.sound_effect && char.match(/[^ 　\r\n]/)) {
                    if (interval <= 20) {
                        if (this.pos % 2 === 0) {
                            this.sound();
                        }
                    } else {
                        this.sound();
                    }
                }
                this.curr += char;
                if (this.finished
                    || (char.match(/[^\r\n]/u) && this.next.match(/[\r\n]/u))) {
                    this.stop();
                    this.period = 0;
                    if (this.finished) {
                        this.$emit("finished", true);
                    }
                    setTimeout(() => {this.$emit("scrollBottom")});
                } else {
                    if (this.curr.length > 1000) {
                        this.done += this.curr;
                        this.curr = "";
                    }
                    let diff = 0;
                    if (interval == 10) {
                        diff = 0;
                    } else if (char.match(/[、．」』！？!\?…]/u) && this.next.match(/[^、．。」』！？!\?…]/u)) {
                        diff = 200;
                    } else if (char.match(/[。]/u) && this.next.match(/[^」』]/u)) {
                        diff = 400;
                        this.period++;
                    }
                    if (this.period >= 2) {
                        this.period = 0;
                        this.stop();
                    } else {
                        this.timerId = setTimeout(this.increment, interval + diff, interval);
                    }
                    this.$emit("scrollBottom");
                }
            } catch (error) {
                console.error(error);
                this.timerId = setTimeout(this.increment, interval, interval);
            }
        },
        keyEvent(ev) {
            if (ev.key == "Enter" || ev.code == "Space") {
                this.start();
            } else if (ev.key == "Escape" || ev.key == "Backspace") {
                this.stop();
            }
        },
        savePos() {
            if (this.pos > 0) {
                const csrf = $("meta[name='csrf-token']").attr("content");
                const payload = new FormData();
                payload.append("_token", csrf);
                payload.append("book_id", this.section.book_id);
                payload.append("section_id", this.section.id);
                payload.append("pos", this.pos);
                navigator.sendBeacon("/author/pos/save", payload);
            }
        },
        abortEpisode() {
            clearTimeout(this.timerId);
            clearTimeout(this.saveId);
            this.savePos();
        },
        sound() {
            this.source.start(0);
            this.source = this.audio.createBufferSource();
            this.source.buffer = this.buffer;
            this.source.connect(this.audio.destination);
        },
        getSize() {
            const vh = (window.innerHeight - 20) * 0.01;
            if (document.querySelector(".vertical-s")) {
                document.querySelector(".vertical-s").style.setProperty('--vh', `${vh}px`);
            } else if (document.querySelector(".vertical-p")) {
                return;
            } else {
                setTimeout(() => this.getSize(), 300);
            }
        },
        startReadingTracker() {
            this.startReading = true;
        }
    },
    watch: {
        section(n, o) {
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
            if (! this.$store.state?.is_horizontal) {
                $(".vertical")[0].scrollLeft = 0;
            }
            this.initialized = false;
            this.init();
            // 履歴読み込み
            if (!o?.id) {
                axios.get("/author/pos", {params: {
                    section_id: n.id,
                    book_id: n.book_id,
                }}).then(res => {
                    this.pos = parseInt(res.data);
                    this.init();
                }).catch(err => { alert.err(err.response) });
            } else {
                this.pos = 0;
                this.init();
            }
        },
    },
    computed: {
        append() {
            if (this.timerId || this.finished || !this.$store.state.output_style) {
                return "";
            }
            return "<span style='animation: blink 1s infinite alternate;backface-visibility: hidden;'>⏎</span>";
        },
        finished() {
            return this.pos >= this.section?.body?.length;
        },
        sectionClass() {
            const cls = {};
            if (this.loading) {
                cls.loading = true;
            }
            if (this.$store.state.is_horizontal == 0 && !this.preview) {
                cls["vertical-s"] = true;
            }
            if (this.$store.state.is_horizontal == 0 && this.preview) {
                cls["vertical-p"] = true;
            }
            if (this.$store.state.font) {
                cls[this.$store.state.font] = true;
            }
            return cls;
        },
    },
    mounted() {
        $(window).on("resize", this.getSize);
        this.getSize();
        this.initialized = false;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "setLayout") {
                this.stop();
                this.init();
            }
        });
    },
    created() {
        window.addEventListener("beforeunload", this.abortEpisode);
    },
    destroyed() {
        $(window).off("resize");
        window.removeEventListener("beforeunload", this.abortEpisode);
    },
}
</script>